import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CallStat } from 'src/app/model/call/call.model';
import { CallService } from 'src/app/services/http/call/call.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-call-dap-infos',
  templateUrl: './call-dap-infos.component.html',
  styleUrls: ['./call-dap-infos.component.scss']
})
export class CallDapInfosComponent implements OnInit {

  /**
   * Array of Codes pannes to search and display
   */
  @Input() pannes!: string[];

  /**
   *  List of Calls found
   */
  callStats!: CallStat[];

  get displayedColumn(): string[] {
    const result: string[] = ['date', 'numSerie', 'nom', 'action'];
    return result;
  }
  constructor(private service: CallService, private utils: UtilsService) { }

  ngOnInit(): void {
    this.loadPannes();
  }

  loadPannes() {
    if (this.pannes.length > 0) {
      this.service.getCallsCodes(this.pannes)
        .subscribe((calls) => {
          //console.log(calls)
          this.callStats = calls;
        });
    }
  }

  ngOnChanges(change: SimpleChanges) {
    this.pannes = change.pannes.currentValue;
    this.loadPannes();
  }

  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }

}
